import React, { useState, useEffect } from 'react';
import axios from 'axios';

const FilterControls = ({ updateStatus, updateIsland, requery, currentStatus, currentIsland, viewType }) => {
    const [islands, setIslands] = useState([]);
    const [lang, setLang] = useState('');


    useEffect(() => {
        // Get the HTML lang attribute
        const htmlLang = $('html').attr('lang');
        setLang(htmlLang);

        // Fetch islands data from API
        axios.get(window.Laravel.apiUrl + '/cities', {
            params: {
                lang: $('html').attr('lang'),
                per_page: -1,
            }
        })
        .then(res => {
            setIslands(res.data || []);
        })
        .catch(error => {
            console.error('Error fetching islands:', error);
        });
    }, []);

    const handleStatusChange = (status) => {
        updateStatus(status);
    };

    useEffect(() => {
        requery();
    }, [currentStatus]);

    const handleIslandChange = (e) => {
        updateIsland(e.target.value).then(() => requery());
    };

    const handleClearFilters = () => {
        updateStatus(null);
        updateIsland('').then(() => requery());
    };

    // Check if any filter is active
    const isFilterActive = currentStatus || currentIsland;

    return (
        <div className="filter-controls d-flex justify-content-center align-items-center position-absolute p-4"
             style={{ background: "rgba(255,255,255, 0.8)", borderRadius: '10px', top: '70px', left: '50%', transform: 'translateX(-50%)', zIndex: 1000 }}>
            {viewType !== 'facilities' && (
                <div className="btn-group mr-3">
                    <button
                        className={`btn pt-2 pb-3 ${currentStatus === 'ONGOING' ? 'btn-primary' : 'btn-outline-primary'}`}
                        onClick={() => handleStatusChange('ONGOING')}
                    >
                        {lang === 'dv' ? "ކުރިއަށްދާ" : "Ongoing"}
                    </button>
                    <button
                        className={`btn pt-2 pb-3 ${currentStatus === 'COMPLETED' ? 'btn-primary' : 'btn-outline-primary'}`}
                        onClick={() => handleStatusChange('COMPLETED')}
                    >
                        {lang === 'dv' ? "ނިމިފައި" : "Completed"}
                    </button>
                </div>
            )}

            <select
                className="form-control mr-3 border-info border fw-medium"
                style={{ width: 'auto', background: 'rgba(255,255,255,0.8)' }}
                onChange={handleIslandChange}
                value={currentIsland || ''}
            >
                <option value="">{lang === 'dv' ? "ހުރިހާ ރަށެއް" : "All Islands"}</option>
                {islands.map(island => (
                    <option key={island.id} value={island.id}>
                        {island.formatted_name}
                    </option>
                ))}
            </select>

            {isFilterActive && (
                <button
                    className="btn btn-outline-danger"
                    onClick={handleClearFilters}
                >
                    {lang === 'dv' ? "ކެންސަލް" : "Clear"}
                </button>
            )}
        </div>
    );
};

export default FilterControls;
